import React from 'react';
import { NavLink } from 'react-router-dom';

const Header: React.FC = () => {
    return (
        <header className="header">
            <div className="container">
                <h1>Markdown Tools</h1>
                <nav>
                    <ul>
                        <li><NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink></li>
                        <li><NavLink to="/tools" className={({ isActive }) => isActive ? "active" : ""}>Tools</NavLink></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;